<template>
  <div class="filter-top-select">
    <span
      v-for="(item,index) in list"
      :key="index"
      :class="{'is_active':is_select==item.id}"
      @click="handleChange(item)">{{item.name}}</span>
  </div>
</template>

<script>
export default {
  name: 'filter-top-select',
  props:{
    value: {
      type: [String, Boolean, Number],
      default: 0
    },
    list:{
      type:Array,
      default:()=>([])
    }
  },
  data(){
    return{
      is_select:0
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.is_select = val
      }
    }
  },
  methods:{
    handleChange(item){
      this.is_select = item.id
      this.$emit('change',item)
    }
  }
}
</script>

<style scoped lang="scss">
.filter-top-select{
  margin-bottom: 15px;
  border-bottom: 1px solid #E1E4E8;
  //padding-bottom: 16px;
  display: flex;
  span{
    padding: 12px 16px 10px 16px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #586069;
    display: block;
    cursor: pointer;
    &.is_active{
      color: #24292E;
      border: 1px solid #E1E4E8;
      border-bottom: 0;
      background: #fff;
      margin-bottom: -1px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
    &:first-child{
      margin-left: 10px;
    }
  }
}
</style>
